import { Injectable } from '@angular/core';
import { of, Observable } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import {
  LoadOrders,
  LoadOrdersFail,
  LoadOrdersSuccess,
  OrdersActionTypes
} from './actions';
import { OrderService } from '../../services/order.service';

@Injectable()
export class OrdersEffects {
  
  public loadOrders$: Observable<
    LoadOrdersFail | LoadOrdersSuccess
  > = createEffect(() => this.actions$.pipe(
    ofType(OrdersActionTypes.Load),
    switchMap((action: LoadOrders) =>
      this.orderService.getOrders(action.payload.dealId).pipe(
        map(orders => new LoadOrdersSuccess(orders)),
        catchError(error =>
          of(new LoadOrdersFail(error && (error as Error).message))
        )
      )
    )
  ));

  constructor(public orderService: OrderService, private actions$: Actions) {}
}
